<template>
	<div class="pageContainer app-container">

		<el-row>
			<el-col :span="24">
				<el-form :inline="true" :model="queryForm" style="margin-top: 10px;">
					<el-form-item label="名称" min-width="120">
						<el-input v-model="queryForm.keyword" placeholder="请输入关键字"></el-input>
					</el-form-item>


					<el-form-item label="栏目分类" min-width="120">
						<el-select v-model="queryForm.type_name" style="width: 180px;" placeholder="请选择分类">
							<el-option v-for="item in TypeList" :key="item.id" :label="item.type_name"
								:value="item.type_name">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="发布时间" min-width="120">
						<el-date-picker v-model="queryForm.date" style="width: 180px;" placeholder="请选择日期"
							value-format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>


					<el-form-item>
						<el-button type="primary" @click="search">搜索</el-button>
						<el-button type="primary" icon="el-icon-plus" @click="add">添加</el-button>

					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<el-table :data="DataList" stripe border>
			<el-table-column type="index" label="编号" width="80">
			</el-table-column>
			<el-table-column prop="cover" label="封面" width="120">
				<template slot-scope="scope">
					<div style="width: 100px; height: 50px; overflow: hidden;">
						<img :src="scope.row.cover" style="width: 100px; vertical-align: middle;"
							v-viewer />
					</div>

				</template>
			</el-table-column>
			<el-table-column prop="name" label="标题" min-width="230">
				<template slot-scope="scope">
					{{scope.row.title}}
				</template>
			</el-table-column>



			<el-table-column prop="atype" label="类型" width="120">
			</el-table-column>
			<el-table-column prop="atype" label="置顶" width="120">
				<template slot-scope="scope">
					<div @click="setTop(scope.row)">
						<img v-if="scope.row.top" src="/images/ding.png" style="width: 20px;cursor: pointer;">
						<span v-else style="cursor: pointer; color: #00A0E9;">否</span>
					</div>

				</template>
			</el-table-column>
			<el-table-column prop="atype" label="小程序路径" width="200">
				<template slot-scope="scope">
					<div>
						/pages/web/web?t=a&id={{scope.row.id}}
					</div>

				</template>
			</el-table-column>


			<el-table-column prop="id" label="日期" width="180">
				<template slot-scope="scope">
					{{scope.row.udate}}

				</template>
			</el-table-column>

            <el-table-column prop="switch" label="显示状态" width="120">
                <template slot-scope="scope">
                    <span style="color: orangered;" v-if="scope.row.switch==0">隐藏</span>
                    <span style="color: seagreen;" v-if="scope.row.switch==1">显示</span>
                </template>
            </el-table-column>

			<el-table-column prop="status" label="状态" width="120">
				<template slot-scope="scope">
					<span style="color: orangered;" v-if="scope.row.status==0">草稿</span>
					<span style="color: seagreen;" v-if="scope.row.status==1">已发布</span>
				</template>
			</el-table-column>
			<el-table-column prop="readcount" label="阅读数" width="120">

			</el-table-column>

			<el-table-column fixed="right" label="操作" width="150">
				<template slot-scope="scope">

					<el-button type="text" @click="viewInfo(scope.row)">查看</el-button>

					<el-button v-if="auth.edit" type="text" @click="viewDetail(scope.row)">统计</el-button>
					<el-button v-if="scope.row.create_uid==userinfo.union_id" type="text" @click="editItem(scope.row)">
						编辑</el-button>
					<el-button v-if="scope.row.create_uid==userinfo.union_id" type="text"
						@click="deleteItem(scope.row)">删除</el-button>

				</template>
			</el-table-column>
		</el-table>


		<phone v-if="showPhone" :id="EditItem.id"></phone>
	</div>
</template>

<script>
	import phone from "./articleinfo"
	export default {
		components: {
			phone
		},
		data() {
			return {
				temphead: "../../../static/temphead.jpg",
				queryForm: {
					type: "title",
					keyword: "",
					dept_id: "",
					type_name: ""
				},
				activeName: "first",
				DataList: [],
				dialogVisible: false,
				Page: {
					current_page: 1,
					next_page: 2,
					pre_page: 20,
					per_page: 20,
					total_page: 0,
					count: 0
				},
				product_catalog: [],
				userinfo: {},
				datainfo: [],
				read_teacher: [],
				read_teacher_num: 0,
				read_no_teacher: [],
				read_no_teacher_num: 0,
				read_student: [],
				detailTitle: "",
				EditItem: null,
				//按钮权限
				auth: {
					edit: false,
					delete: false
				},
				TypeList: [],
				DeptData: [],
				showPhone: false

			}
		},

		mounted() {



			this.getTypeList();
			this.search()



		},
		methods: {
			getTypeList() {
				this.TypeList = [{
					type_name: "校内新闻",
					id: 1
				}, {
					type_name: "其他",
					id: 2
				}]
			},

			paginate(val) {
				this.Page.current_page = val;
				this.query(val)
			},
			search() {
				this.query(1);
			},
			query(page) {

				this.$http.post('/api/article_list_list', {
					page: this.Page.current_page,
					pagesize: this.Page.pre_page

				}).then(res => {
					this.DataList = res.data.data;
					this.Page = res.data.page
				});
			},
			update(item) {

				sessionStorage.setItem("product", JSON.stringify(item))

				this.$router.push("/proedit/" + item.id)
			},
			add() {
				this.$router.push("/aedit")
			},
			deleteItem(item) {
				this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post("/api/article_list_delete", {
						id: item.id
					}).then(res => {
						this.$message({
							type: 'success',
							message: '删除成功'
						});

						this.query();
					})

				}).catch(() => {

				});
			},


			viewInfo(item) {

				this.EditItem = item
				this.showPhone = true
				this.$http.post("/api/article_info", {
					id: item.id,

				}).then(res => {

				})
			},

			editItem(item) {
				this.$router.push("/aedit?id=" + item.id)
			},
			setTop(item) {
				this.$http.post("/api/article_top", {
					id: item.id,
					top: item.top ? 0 : 1
				}).then(res => {
					this.$message({
						type: 'success',
						message: '置顶成功'
					});

					this.query();
				})
			},

			closePhone() {
				this.showPhone = false
			}




		}
	}
</script>
<style scoped>
	.product-status {
		padding-bottom: 10px;
		border-bottom: 5px solid #e8e8e8;
	}

	.arttile {
		font-size: 18px;
		color: #333333;
		padding: 20px 0;
	}

	.typeitem {
		display: inline-block;
		border: 1px solid #ccc;
		border-radius: 4px;
		padding: 0px 10px;
	}

	.contentcontent {
		padding: 20px 0;
	}

	.attaches {
		padding: 20px 0;
	}

	.attitem {
		color: #0785D1;
		cursor: pointer;
	}

	.useritem {
		width: 200px;
		display: inline-block;
		vertical-align: top;
		margin-bottom: 5px;
		margin-right: 5px;
		border: 1px solid #f6f6f6;
		padding: 5px;
	}

	.useritem image {
		vertical-align: middle;
	}
</style>
